angular
	.module 'App.Repository'
	.factory 'PusherRepository', ['BaseRepository', (BaseRepository) ->
		class PusherRepository extends BaseRepository
			@resource = '/pusher'
			@isRestricted = true

			getAuthUrl: ->
				return @getUrl('/pusher', '/auth')

			listChannels: (shopId = null) ->
				endpoint = if shopId? then "channels/#{shopId}" else 'channels'

				return @getEntity(endpoint)

		return new PusherRepository
	]
